var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(['apeiron_uat', 'apeiron'].includes(_vm.$store.state.tenantId))?_c('apeiron-product-list'):_c('default-product-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }